const objectMap = (object, mapFn) =>
   Object.entries(object).reduce(
      (acc, [key, val]) => ({ ...acc, [key]: mapFn(val) }),
      {}
   );

export { objectMap };
